var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"info-button",class:{ 'info-button--keep-alive': _vm.keepTooltipAlive, 'info-button--small': _vm.small },on:{"click":_vm.toggleKeepTooltip}},[_vm._v("\n  ?\n  "),_c('div',{staticClass:"info-button__text",class:{
      'info-button__text--bottom': _vm.openTo === 'bottom',
      'info-button__text--top': _vm.openTo === 'top' || _vm.openTo == null,
    }},[_vm._t("default"),_vm._v(" "),(_vm.text)?[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }